import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useIconProps } from '../useIconProps';

var Error = function Error(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M9.517 8l2.274-2.275a.715.715 0 000-1.01l-.505-.506a.715.715 0 00-1.011 0L8 6.483 5.725 4.21a.715.715 0 00-1.01 0l-.506.505a.715.715 0 000 1.01l2.274 2.276-2.274 2.274a.715.715 0 000 1.01l.505.506a.715.715 0 001.011 0L8 9.517l2.275 2.274a.716.716 0 001.01 0l.506-.505a.715.715 0 000-1.01L9.517 8z"
  }));
};

Error.displayName = 'Error';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Error.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Error;